module.exports = __webpack_public_path__ + "img/id.cf03de63.svg";